export default __webpack_public_path__ + "static/media/expertise_m.b3bfb992.jpg";